export default __webpack_public_path__ + "static/media/d-Icon-round-hr-512x512px.6ea61f5f.png";